module.exports = "/images/es.svg?49925d3c33e37d0942553c2119354f80";